import axios from 'axios';
const URL_API_DIATRABAJO = process.env.VUE_APP_URL_API_DIATRABAJO;

export class DiatrabajoApiService {

  /**
   * Dado el id de un calendario laboral, devuelve los Diatrabajo asociados
   * 
   * @param {*} calenlab 
   * @return Diatrabajo[]
   */
  findAllDiatrabajo(diatrabajo) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_DIATRABAJO}findAll`;
    return axios
      .post(url, diatrabajo, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
}
